import { TypographyH4 } from '@talentmesh/ui/components/typography';
import type { PercentileLevel } from '@talentmesh/utils';
import ResultsTalentScoreCircularProgress from './ResultsTalentScoreCircularProgress';
import UIStrings from '@/Utils/UIStrings';

interface CandidateResultTalentScoreGroupProps {
    level: PercentileLevel;
    progress?: number;
}

function CandidateResultTalentScoreGroup({ level, progress }: CandidateResultTalentScoreGroupProps) {
    return (
        <div className="flex flex-row items-center gap-2">
            <TypographyH4>{UIStrings.TalentScore}</TypographyH4>
            <ResultsTalentScoreCircularProgress level={level} progress={progress} />
        </div>
    );
}

export default CandidateResultTalentScoreGroup;
